import { useMemo } from 'react'
import qs from 'qs'

import { useQuery } from '@tanstack/react-query'

import { useApi } from '@tabeeb/modules/shared/utils/API/hooks'
import { UserSearchInfoResponse } from '@tabeeb/contracts/main-api/swagger-main-api'

import { UsersQueryKeys } from '../queries'

export interface UseUsersByIdentityProps {
  identityGuids: string[]
  enabled?: boolean
}

const useUsersByIdentity = ({ identityGuids, enabled = true }: UseUsersByIdentityProps) => {
  const { mainApi: api } = useApi()

  const queryKey = [UsersQueryKeys.UsersByIdentity, identityGuids]
  const query = useQuery<UserSearchInfoResponse[]>({
    queryKey,
    queryFn: () =>
      api.users.getUsersByIdentityGuidsAsync(
        { IdentityGuids: identityGuids },
        {
          paramsSerializer: (params) => qs.stringify(params, { allowDots: true }),
        }
      ),
    enabled: enabled && identityGuids.length > 0,
  })

  return useMemo(
    () => ({
      loading: query.isFetching,
      loaded: query.isSuccess,
      users: query.data ?? [],
    }),
    [query.isFetching, query.isSuccess, query.data]
  )
}

export default useUsersByIdentity
